import React from "react";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import { CSVLink } from "react-csv";

const ReportSection = ({ barData = [], pieData = [] }) => {
  if (!Array.isArray(barData) || !Array.isArray(pieData)) {
    return <p>Error: Invalid data provided to ReportSection.</p>;
  }

  // Safely calculate summaries
  const totalCases = barData.reduce((sum, item) => sum + (item?.cases || 0), 0);
  const mostCasesRegion = barData.reduce(
    (max, item) => ((item?.cases || 0) > (max?.cases || 0) ? item : max),
    barData[0]
  );

  const topCrisis = pieData.reduce(
    (max, item) => ((item?.value || 0) > (max?.value || 0) ? item : max),
    pieData[0]
  );

  const csvData = [
    ["Region", "Cases"],
    ...barData.map((item) => [item.region, item.cases]),
    [],
    ["Crisis Type", "Value"],
    ...pieData.map((item) => [item.type, item.value]),
  ];

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Crisis Report Summary", 20, 20);
    doc.setFontSize(12);
    doc.text(`Total Reported Cases: ${totalCases}`, 20, 40);
    doc.text(
      `Most Affected Region: ${mostCasesRegion?.region || "N/A"} (${
        mostCasesRegion?.cases || 0
      } cases)`,
      20,
      50
    );
    doc.text(
      `Top Crisis Type: ${topCrisis?.type || "N/A"} (${
        topCrisis?.value || 0
      }%)`,
      20,
      60
    );
    doc.save("crisis_report.pdf");
  };

  return (
    <div
      style={{
        marginTop: "2rem",
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      }}
    >
      <h3>Crisis Summary Report</h3>
      {/* <p><strong>Total Cases:</strong> {totalCases}</p>
      <p><strong>Most Affected Region:</strong> {mostCasesRegion?.region || "N/A"} ({mostCasesRegion?.cases || 0})</p>
      <p><strong>Top Crisis Type:</strong> {topCrisis?.type || "N/A"} ({topCrisis?.value || 0}%)</p> */}

      <div
        style={{
          marginTop: "2rem",
          display: "flex",
          justifyContent: "center",
          gap: "1rem",
        }}
      >
        <CSVLink data={csvData} filename="crisis_report.csv">
          <Button
            icon={<DownloadOutlined />}
            type="primary"
            style={{ background: "darkgreen", padding: "1.5rem" }}
          >
            Download CSV
          </Button>
        </CSVLink>

        <Button
          onClick={downloadPDF}
          icon={<DownloadOutlined />}
          type="primary"
          danger
          style={{ background: "darkblue", padding: "1.5rem" }}
        >
          Download PDF
        </Button>
      </div>
    </div>
  );
};

export default ReportSection;
